import { useSelector } from 'react-redux';
import { isFeatureEnabled } from '../features/auth.store';

export const ROLE = {
  SA: 'ROLE_TYPE_SUPER_ADMIN_ROLE',
  //TA: 'ROLE_TENANT_ADMIN',
  TA: 'ROLE_TYPE_TENANT_ROLE',
  //SU: 'ROLE_SITE_USER',
  SU: 'ROLE_TYPE_SITE_ROLE',
  // ST: 'ROLE_SITE_SERVICE_TECHNICIAN',
  ST: 'ROLE_TYPE_MINEARC_ROLE',
  MAST: 'ROLE_MINE_ARC_SERVICE_TECHNICIAN',
  MAV: 'ROLE_MINE_ARC_USER',
  SC: 'ROLE_MINE_ARC_SERVICE_COORDINATOR',
  TC: 'ROLE_TRAINING_COORDINATOR',
  //BDM: 'ROLE_BUSINESS_DEVELOPMENT_MANAGER',
  BDM: 'ROLE_TYPE_MINEARC_ROLE',
  SP: 'ROLE_SERVICE_PROVIDER',
  MINEARC: 'ROLE_TYPE_MINEARC_ROLE',
  BUILD:'BUILD_VIEW',
  VIEW_ALL_CHAMBERS: 'VIEW_ALL_CHAMBERS'
};

const FEATURES = {
  view_company: [ROLE.SA, ROLE.MINEARC],
  add_company: [ROLE.SA, ROLE.MINEARC],
  add_organizations: [ROLE.SA, ROLE.MINEARC],
  add_users_to_organization: [ROLE.SA],
  add_sites: [ROLE.SA, ROLE.MINEARC],
  add_users_to_sites: [ROLE.SA, ROLE.MINEARC],
  add_chambers: [ROLE.SA,ROLE.BDM, ROLE.MINEARC],
  add_chambers_to_sites: [ROLE.SA, ROLE.BDM, ROLE.MINEARC],
  view_service_report: [ROLE.SA, ROLE.TA, ROLE.SU, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC], // allow all
  view_after_service_report: [ROLE.SA, ROLE.SU, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC], // allow all except tenant admin
  add_documents: [ROLE.SA, ROLE.MINEARC],
  view_documents: [ROLE.SA, ROLE.TA, ROLE.SU, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC], // allow all
  service_a_chamber: [ROLE.SA, ROLE.ST, ROLE.MAST, ROLE.BDM, ROLE.MINEARC],
  audit_service_a_chamber: [ROLE.SA, ROLE.MAST, ROLE.MINEARC],
  commission_service_a_chamber: [ROLE.SA,ROLE.MAST, ROLE.MINEARC],

  edit_service_form: [ROLE.SA,ROLE.ST, ROLE.MAST, ROLE.SC],
  view_chambers_of_a_site: [ROLE.SA, ROLE.TA, ROLE.SU, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC],
  view_services_of_a_site: [ROLE.SA, ROLE.TA, ROLE.SU, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC],
  view_sites_of_the_organization: [ROLE.SA, ROLE.TA, ROLE.ST, ROLE.MAST, ROLE.MAV, ROLE.SC, ROLE.SP, ROLE.MINEARC],
  approve_the_service_form: [ROLE.MAST,ROLE.SA, ROLE.MINEARC],

  view_users: [ROLE.SA, ROLE.SP, ROLE.MINEARC],
  view_schedule: [ROLE.TC, ROLE.SC, ROLE.BDM, ROLE.SP,ROLE.SA, ROLE.MINEARC],
  view_build: [ROLE.SA]
};

export const fromFeatureMatrix = (user, key) => {
  if (FEATURES[key] && FEATURES[key].length > 0) {
    return FEATURES[key].indexOf(user) >= 0;
  }
  return true;
};

export const useFeature = (key) => useSelector(isFeatureEnabled)(key);
